import configAxios from "./axiosConfig";

export const post = async ({ path, data, token }) => {
  const response = await configAxios.post(path, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return response.data;
};
